import { get, isFunction } from 'lodash';
import Wix from './wix-sdk-polyfill';

const POPUP_URL = `https://apps.wix.com/_api/members-area/public/modal/join-community`;

const onClose = (callback) => ({ message }) => {
  if (isFunction(callback)) {
    callback(get(message, 'payload.inCommunity', false));
  }
};

export const showJoinCommunityPopup = (callback) => {
  Wix.openPopup(
    POPUP_URL,
    '100%',
    '100%',
    { origin: Wix.WindowOrigin.FIXED, placement: Wix.WindowPlacement.CENTER },
    onClose(callback),
    Wix.Theme.BARE,
  );
};
